import { render, staticRenderFns } from "./RejectSrfModal.vue?vue&type=template&id=20fd6822&"
import script from "./RejectSrfModal.vue?vue&type=script&lang=ts&"
export * from "./RejectSrfModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20fd6822')) {
      api.createRecord('20fd6822', component.options)
    } else {
      api.reload('20fd6822', component.options)
    }
    module.hot.accept("./RejectSrfModal.vue?vue&type=template&id=20fd6822&", function () {
      api.rerender('20fd6822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SparePartRequest/RejectSrfModal.vue"
export default component.exports